import React, { useState, useEffect } from "react";
import { apiJson } from "../../utils/api";

const SubjectSelection = () => {
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [selections, setSelections] = useState({});
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      const data = await apiJson("/api/student/admission/subjects");
      setCategories(data.categories || []);

      // Pre-fill existing selections
      const existing = {};
      if (data.selections) {
        for (const sel of data.selections) {
          existing[sel.subjectCategoryId] = sel.selectedOption;
        }
      }
      setSelections(existing);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    const selArray = Object.entries(selections)
      .filter(([_, v]) => v)
      .map(([catId, option]) => ({
        subjectCategoryId: parseInt(catId),
        selectedOption: option,
      }));

    try {
      await apiJson("/api/student/admission/subjects", {
        method: "PUT",
        body: JSON.stringify({ selections: selArray }),
      });
      setMessage("Subject selections saved!");
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <p className="text-gray-500">Loading...</p>;

  if (categories.length === 0) {
    return (
      <div className="max-w-2xl mx-auto bg-white p-6 rounded shadow">
        <h1 className="text-xl font-bold text-gray-800 mb-2">Subject Selection</h1>
        <p className="text-gray-500">No subject options available for your degree. This may mean your degree does not have a subject basket configured yet.</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-xl font-bold text-gray-800 mb-4">Subject Selection</h1>

      {message && <div className="bg-green-50 text-green-700 p-3 rounded mb-4 text-sm">{message}</div>}
      {error && <div className="bg-red-50 text-red-600 p-3 rounded mb-4 text-sm">{error}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
        {categories.map((cat) => (
          <div key={cat.id} className="bg-white p-4 rounded shadow">
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              {cat.name} ({cat.code})
            </label>
            <select
              value={selections[cat.id] || ""}
              onChange={(e) => setSelections({ ...selections, [cat.id]: e.target.value })}
              className="w-full px-2 py-1.5 border rounded text-sm"
              required
            >
              <option value="">Select...</option>
              {cat.options.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
        ))}

        <button
          type="submit"
          className="bg-indigo-600 text-white px-6 py-2 rounded hover:bg-indigo-700 transition"
        >
          Save Selections
        </button>
      </form>
    </div>
  );
};

export default SubjectSelection;
